<template lang="pug">

  form-group-row(:form="form", :label="label", name="preferred_location_id", required)
    v-select.form-control(v-model="preferred_location", label="display_name", :options="locations",
      :searchable="false", :class="{'is-invalid': form.errors.has('preferred_location_id')}")

</template>

<script>

import LocationService from '../../services/location';

export default {
  name: 'user-input-preferred-location',

  props: {
    label: {
      type: String,
      default: 'Preferred location',
    },
  },

  data: () => ({
    form: null,
    locations: [],
    preferred_location: null,
  }),

  watch: {
    preferred_location(val) {
      this.form.preferred_location_id = val ? val.id : null;
    }
  },

  async created() {
    this.form = this.$parent.form;

    this.form.preferred_location_id = this.$parent.user ? this.$parent.user.meta.preferred_location_id : null;

    this.locations = await LocationService.index();

    this.preferred_location = this.locations.find((x) => x.id == this.form.preferred_location_id);
  },
}

</script>
